import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  displaySettingsSelector,
  getSavedVideosFeatureSelector,
  integrationSelector,
  userIdSelector,
  websiteSelector,
} from 'common/selectors';
import { establishCommunicationChannelWithParentFrame, isIframe } from 'integration/integration.utils';
import { integrationLayoutChangedAction } from 'common/actions';
import { qsProps } from 'utils/common';

export const WebsiteLoader = withRouter(
  connect(
    (state) => ({
      website: websiteSelector(state),
      displaySettings: displaySettingsSelector(state),
      integration: integrationSelector(state),
      savedVideosEnabled: getSavedVideosFeatureSelector(state),
      userId: userIdSelector(state),
    }),
    (dispatch) => ({ dispatch })
  )((props) => {
    const { i18n } = useTranslation();
    const urlQueryParams = qsProps(props).match.params;

    if (urlQueryParams.layout && props.integration.layout !== urlQueryParams.layout) {
      props.dispatch(integrationLayoutChangedAction(urlQueryParams.layout, urlQueryParams.portalUrl));

      if (props.displaySettings.languages.length > 1) {
        i18n.changeLanguage(urlQueryParams.lang || 'en-US');
      } else {
        const lang = props.displaySettings.languages[0];
        i18n.changeLanguage(lang);
      }
    }

    if (isIframe(props.integration)) {
      establishCommunicationChannelWithParentFrame(props, urlQueryParams);
    }

    return props.children;
  })
);
